// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"223":"76289f2ae872c9e9ae1a","245":"d823bb480718295c5cb8","453":"107cd3b2e6c07369e0aa","454":"593bfee60ae87f488e6e"}[chunkId] + ".js";
};